<template>
  <div>
    <div class="filter-tags" v-show="filters.negative.length">
      <div class="warning-category">出现以下类型舆情时发出警告:</div>
      <news-list-filter-panel class="panel" :filters="filters" @change="onFilterPanelChange"></news-list-filter-panel>
      <div class="open-close-panel" @click="onShowSelectCategory"></div>
      <div class="hr"></div>
    </div>
    <el-collapse-transition v-if="isShowSelectCategory">
      <div>
        <div class="select-category" >选择类别</div>
        <div class="news-list-filter" >
          <multi-select class="negative" :selected-filters="filters.negative" :items="newsListFilterstest" allSelectedText="全部风险" @change="onNegativeFilterChange"></multi-select>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import NewsListFilterPanel from '@/components/news-monitor/NewsListFilterPanel';
import MultiSelect from '@/components/common/MultiSelect';
import authService from '@/services/authService';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      isShowSelectCategory: true,
      username: '',
      newsListFilterstest: []
    };
  },
  props: {
    filters: {
      type: Object
    },
    name: {
      // 公司名
      type: String
    }
  },
  methods: {
    onFilterPanelChange(res) {
      this.filters.negative = res.negative;
      this.$emit('change', this.filters.negative);
    },
    onNegativeFilterChange(items) {
      this.filters.negative = items.selectedList;
      this.$emit('change', this.filters.negative);
    },
    onShowSelectCategory() {
      this.isShowSelectCategory = !this.isShowSelectCategory;
    },
    getFilters() {
      QuestionQuery.getNewsListFiltersData(this.username, this.name, 'all', []).then(res => {
        this.newsListFilterstest = res.negative;
      });
    }
  },
  components: {
    NewsListFilterPanel,
    MultiSelect
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getFilters();
  }
};
</script>

<style lang="scss" scoped>
  .filter-tags {
    .panel {
      display: inline-block;
      width:658px;
    }
    .open-close-panel {
      display: inline-block;
      width: 18px;
      height: 18px;
      vertical-align: middle;
      background-image: url("../../assets/img/caret-down1.svg");
      background-size: cover;
    }
  }
  .warning-category {
    padding-top:16px;
    padding-bottom:12px;
    font-size: 14px;
    color: #ffffff;
  }
  .select-category {
    padding-top: 16px;
    padding-bottom:10px;
    font-size: 14px;
    color: #ffffff;
  }
  .hr {
    margin-top: 14px;
    width: 696px;
    height: 1px;
    background-color: #ffffff;
    opacity: 0.2;
  }
  .news-list-filter {
  /deep/ {
    .positive .item {
      &.active {
        color: #fe4954 !important;
      }    
      &:hover {
        color: #fe4954 !important;
      }
      &.disabled {
        &.active {
          color: #777777 !important;
        }    
        &:hover {
          color: #777777 !important;
        }
      }
    }

    .negative .item {
      &.active {
        color: #54cea4 !important;
      }    
      &:hover {
        color: #54cea4 !important;
      }
      &.disabled {
        &.active {
          color: #777777 !important;
        }    
        &:hover {
          color: #777777 !important;
        }
      }
    }
  }
}
</style>


